import axios from 'axios';
import { useQuery } from 'react-query';

const API_HOST = process.env.REACT_APP_API_HOST;

export const workspaceSettingsQueryKey = ['workspace-settings'];

export const fetchWorkspaceSettings = async () => {
  const response = await axios.get(`${API_HOST}/v1/workspace`);
  const result = response.data;

  if (result.status !== 'GET_WORKSPACE_SETTINGS_SUCCESS' || !result.data) {
    throw new Error(result.message || 'Could not load workspace settings.');
  }

  return result.data;
};

export const useWorkspaceSettings = () =>
  useQuery(workspaceSettingsQueryKey, fetchWorkspaceSettings, {
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    retry: false,
  });
